"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as e, jsx as a } from "react/jsx-runtime";
import { useTheme as i } from "../../hooks.js";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const v = (_param)=>{
    var { color: o, size: c = 24 } = _param, s = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const h = n(), l = o !== null && o !== void 0 ? o : h ? t.colors.inverse : t.colors.neutralHigh, { skinName: r } = i();
    return r.match(/^o2-new/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, s), {
        children: [
            /* @__PURE__ */ a("path", {
                fill: l,
                d: "M11.893 14.69c-.38 0-.693-.327-.693-.727a4.3 4.3 0 0 1 1.177-2.983l.933-.98c.347-.363.278-1.163 0-1.563s-.762-.655-1.211-.655h-.175c-.484 0-.934.292-1.178.727-.205.364-.624.472-.933.256a.71.71 0 0 1-.244-.98 2.73 2.73 0 0 1 2.389-1.455h.175c.903 0 1.768.436 2.32 1.2.66.907.762 2.543-.103 3.454l-.933.98a2.82 2.82 0 0 0-.762 1.963c-.069.436-.381.764-.762.764M12.552 16.074c0 .402-.31.728-.693.728s-.694-.326-.694-.728.31-.727.694-.727.693.325.693.727"
            }),
            /* @__PURE__ */ a("path", {
                fill: l,
                d: "M3.165 22a.66.66 0 0 1-.484-.216.72.72 0 0 1-.175-.692l1.455-5.565a9.95 9.95 0 0 1-.796-3.89C3.165 6.326 7.287 2 12.346 2c5.06 0 9.182 4.326 9.182 9.636s-4.122 9.636-9.182 9.636c-1.283 0-2.53-.292-3.706-.8l-5.303 1.492C3.302 22 3.234 22 3.165 22m9.178-18.545c-4.298 0-7.795 3.675-7.795 8.181 0 1.236.244 2.4.762 3.49.069.145.069.329.034.508l-1.211 4.623 4.362-1.24c.175-.036.347-.036.484.036 1.04.508 2.183.8 3.326.8 4.331-.036 7.828-3.707 7.828-8.217s-3.497-8.18-7.79-8.18"
            })
        ]
    })) : r.match(/^o2/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, s), {
        children: [
            /* @__PURE__ */ a("path", {
                fill: l,
                d: "M11.893 14.69c-.38 0-.693-.327-.693-.727a4.3 4.3 0 0 1 1.177-2.983l.933-.98c.347-.363.278-1.163 0-1.563s-.762-.655-1.211-.655h-.175c-.484 0-.934.292-1.178.727-.205.364-.624.472-.933.256a.71.71 0 0 1-.244-.98 2.73 2.73 0 0 1 2.389-1.455h.175c.903 0 1.768.436 2.32 1.2.66.907.762 2.543-.103 3.454l-.933.98a2.82 2.82 0 0 0-.762 1.963c-.069.436-.381.764-.762.764M12.552 16.074c0 .402-.31.728-.693.728s-.694-.326-.694-.728.31-.727.694-.727.693.325.693.727"
            }),
            /* @__PURE__ */ a("path", {
                fill: l,
                d: "M3.165 22a.66.66 0 0 1-.484-.216.72.72 0 0 1-.175-.692l1.455-5.565a9.95 9.95 0 0 1-.796-3.89C3.165 6.326 7.287 2 12.346 2c5.06 0 9.182 4.326 9.182 9.636s-4.122 9.636-9.182 9.636c-1.283 0-2.53-.292-3.706-.8l-5.303 1.492C3.302 22 3.234 22 3.165 22m9.178-18.545c-4.298 0-7.795 3.675-7.795 8.181 0 1.236.244 2.4.762 3.49.069.145.069.329.034.508l-1.211 4.623 4.362-1.24c.175-.036.347-.036.484.036 1.04.508 2.183.8 3.326.8 4.331-.036 7.828-3.707 7.828-8.217s-3.497-8.18-7.79-8.18"
            })
        ]
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, s), {
        children: [
            /* @__PURE__ */ a("path", {
                fill: l,
                d: "M16.766 6.25a.42.42 0 0 0 .417.423q.004 0 .011-.003a.417.417 0 0 0 .41-.429v-.17c0-.153.15-.285.255-.375q.04-.035.066-.06l.092-.089c.183-.172.37-.35.37-.757 0-.557-.481-1.157-1.201-1.157-.768 0-1.255.454-1.255 1.154a.418.418 0 0 0 .835 0c0-.134.14-.358.417-.358s.345.25.345.364c0 .146-.129.255-.219.331q-.031.027-.053.047l-.03.029c-.194.188-.46.444-.46.873zM17.635 7.4a.44.44 0 1 1-.88 0 .44.44 0 0 1 .88 0"
            }),
            /* @__PURE__ */ a("path", {
                fill: l,
                d: "M14.755 11.743a1 1 0 0 1-.113-.009c-.414-.061-.75-.462-.75-.888v-1.56h-.11c-.87 0-1.529-.695-1.529-1.613v-3.9c0-.89.723-1.613 1.614-1.613h6.366c.891 0 1.614.723 1.614 1.613v3.902c0 .891-.723 1.614-1.614 1.614h-3.288c-.314.496-.978 1.54-1.11 1.74-.29.445-.705.714-1.08.714m-.889-8.463a.494.494 0 0 0-.492.493v3.902c0 .247.125.493.409.493h.669c.308 0 .56.253.56.56v1.51a450 450 0 0 0 1.151-1.81.56.56 0 0 1 .474-.26h3.596a.494.494 0 0 0 .493-.493V3.773a.494.494 0 0 0-.493-.493zM8.726 15.289c-1.215 0-2.162-.35-2.817-1.045-.62-.653-.93-1.563-.93-2.703s.313-2.05.93-2.703C6.564 8.143 7.51 7.79 8.726 7.79s2.163.353 2.818 1.045c.617.653.93 1.563.93 2.703s-.313 2.05-.93 2.703c-.655.698-1.605 1.048-2.818 1.048m0-6.378c-1.745 0-2.627.885-2.627 2.627s.885 2.628 2.627 2.628c1.743 0 2.628-.886 2.628-2.628s-.885-2.627-2.628-2.627M2.715 21.844h12.02c.31 0 .56-.25.56-.56v-1.04c0-1.344-.356-2.38-1.059-3.09-.703-.708-1.736-1.067-3.075-1.067H6.289c-1.336 0-2.372.361-3.075 1.067s-1.059 1.745-1.059 3.09v1.04c0 .307.252.56.56.56m.56-1.12v-.48c0-1.036.25-1.81.734-2.3.485-.49 1.252-.736 2.28-.736h4.874c1.028 0 1.796.249 2.28.736.485.488.732 1.264.732 2.3v.48z"
            })
        ]
    }));
}, u = v;
export { u as default };
